"use strict";

require('./CompanyDeviationWatcherService.js');

CompanyDeviationWatcherNewCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$translate',
  'CompanyUserService',
  'CompanyDeviationWatcherService',
  'growl'
];

function CompanyDeviationWatcherNewCtrl(
  $scope,
  $state,
  $stateParams,
  $translate,
  CompanyUserService,
  CompanyDeviationWatcherService,
  growl) {

  $scope.categories = [
    'OLYCKA',
    'FORBATTRINGAR',
    'REKLAMATIONER',
    'TILLBUD',
    'AVVIKELSE',
    'EKONOMI',
    'KUND',
    'LEVERANTOR',
    'MILJO'
  ];

  $scope.deviationWatcher = {
    company: $stateParams.companyId,
    watcher: [],
    category: 'OLYCKA',
    description: ''
  };

  var nonWatchersPromise;
  $scope.nonWatchers             = [];

  $scope.updateNonWatchers = function(filter) {
    var p = CompanyUserService.query({companyId: $stateParams.companyId, q: filter, limit: 6}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !$scope.deviationWatcher.watcher.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonWatchers) {
      if(nonWatchersPromise === p) {
        $scope.nonWatchers = nonWatchers;
      }
    });
    
    nonWatchersPromise = p;
  };

  $scope.deleteWatcher = function(watcher) {
    $scope.deviationWatcher.watcher.splice($scope.deviationWatcher.watcher.indexOf(watcher), 1);
  };

  $scope.save = function() {
    CompanyDeviationWatcherService.save({companyId: $stateParams.companyId}, $scope.deviationWatcher, function() {
      growl.addSuccessMessage($translate.instant('deviation.create-deviation-watcher-success'));
      $state.go('^.list');
    },
    function() {
      growl.addErrorMessage($translate.instant('deviation.create-deviation-watcher-failure'));
    });
  };

}


angular.module('dokiv')
  .controller('CompanyDeviationWatcherNewCtrl', CompanyDeviationWatcherNewCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/deviation-watchers/CompanyDeviationWatcherNewCtrl.js
// module id = 340
// module chunks = 0